import { render, staticRenderFns } from "./ProductRow.vue?vue&type=template&id=4f73bfe8"
import script from "./ProductRow.vue?vue&type=script&lang=js"
export * from "./ProductRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports